var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScheduledIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M34.5533 28.4198C36.0025 25.9488 36.8333 23.0714 36.8333 19.9999C36.8333 10.7952 29.3713 3.33325 20.1667 3.33325C10.9619 3.33325 3.5 10.7952 3.5 19.9999C3.5 29.2046 10.9619 36.6666 20.1667 36.6666C22.5473 36.6666 24.8113 36.1674 26.86 35.2681C26.9955 34.3861 27.6205 33.3369 28.059 32.6011C28.1993 32.3654 28.3207 32.1617 28.4005 32.0061C28.8795 31.0732 28.8708 30.5764 28.4005 29.6604C28.3207 29.5048 28.1993 29.3011 28.059 29.0654C27.3685 27.9066 26.2152 25.9706 27.2398 25.1339C27.7435 24.7228 28.7907 25.2883 30.8852 26.4193L32.7423 27.4223C33.4337 27.7954 34.0372 28.1214 34.5533 28.4198Z",
    fill: "#2C8C53"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1667 13.3333V19.9999L22.6667 22.4999",
    stroke: "#172B4D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7423 27.4223C35.4697 28.8949 36.8333 29.6314 36.8333 30.8333C36.8333 32.0351 35.4697 32.7716 32.7423 34.2443L30.8852 35.2473C28.7907 36.3783 27.7435 36.9438 27.2398 36.5326C26.0067 35.5256 27.9278 32.9268 28.4005 32.0061C28.8795 31.0733 28.8708 30.5764 28.4005 29.6604C27.9278 28.7398 26.0067 26.1409 27.2398 25.1339C27.7435 24.7228 28.7907 25.2883 30.8852 26.4193L32.7423 27.4223Z",
    stroke: "#172B4D",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8768 36.5799C21.3147 36.6373 20.744 36.6666 20.1667 36.6666C10.9619 36.6666 3.5 29.2046 3.5 19.9999C3.5 10.7952 10.9619 3.33325 20.1667 3.33325C29.3713 3.33325 36.8333 10.7952 36.8333 19.9999C36.8333 21.1414 36.7185 22.2563 36.5 23.3333",
    stroke: "#172B4D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduledIcon);
export default __webpack_public_path__ + "static/media/scheduled_icon.c89b548534f194177ed6a0c5e524ca29.svg";
export { ForwardRef as ReactComponent };